var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state-inner"},[_c('div',{staticClass:"empty-state-image"},[_c('img',{staticClass:"mb-8",attrs:{"src":_vm.emptyImage,"alt":"empty_state","width":"180","height":"180"}})]),_c('div',{staticClass:"empty-state-title"},[_vm._v("\n      "+_vm._s(_vm.$t('error.sorry_we_could_not_find_what_you_were_looking_for'))+"\n    ")]),_c('div',{staticClass:"empty-state-subtitle",domProps:{"innerHTML":_vm._s(
        _vm.$sanitize(_vm.$t('error.please_try_again_or_contact_support'), {
          allowedTags: ['a'],
        })
      )}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }